import { Component, ElementRef, ViewChild } from '@angular/core';

import UrlUtils from '@shared/Utils/url.utils';
import { FormFieldComponent } from '../form-field.types';
import { FormatNumberPipe } from '@shared/pipes/format-number.pipe';

@Component({
  templateUrl: './decimal-form-field.component.html',
  styleUrls: ['./../form-field.component.scss'],
})
export class DecimalFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  private _originalValue: any;

  public value: any;
  public editing: boolean = false;
  public precision: number = 0;

  constructor(private _formatNumber: FormatNumberPipe) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden && !this.editing ? 'REDACTED' : this.model[this.fieldDef.name];

    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.scale) {
      this.precision = this.fieldDef.meta.scale;
    }

    //SC-40441, Don't format for the latitude and the longitude, or when the value is hidden
    if (this.fieldDef.name === 'latitude' || this.fieldDef.name === 'longitude' || this.fieldDef.meta?.value_hidden) {
      return;
    }

    this.value = this._formatNumber.transform(this.value, this.precision, this.fieldDef);
  }

  updateChangedModel(model: any): void {
    this.model = model;
    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.value = UrlUtils.checkAndEvalFormula(this.value)?.toString();

    if (this.value === '') {
      this.value = null;
    }

    this.onSave();
    this.editing = false;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value ? this.value.replace(/,/g, '') : null });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this._formatNumber.transform(this.value, this.precision, this.fieldDef);
    this._originalValue = this._formatNumber.transform(this.value, this.precision, this.fieldDef);

    //SC-40441, Don't format for the latitude and the longitude
    if (this.fieldDef.name === 'latitude' || this.fieldDef.name === 'longitude') {
      return;
    }

    this.value = this._formatNumber.transform(this.value, this.precision, this.fieldDef);
  }
}
